import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthService } from 'app/core/auth/auth.service';

export abstract class HasRoleDirectiveBase {
    private hasView = false;

    constructor(
        protected templateRef: TemplateRef<any>,
        protected viewContainer: ViewContainerRef
    ) {}

    set hasRole(value: boolean) {
        if (value && !this.hasView) {
            this.viewContainer.createEmbeddedView(this.templateRef);
            this.hasView = true;
        } else if (!value && this.hasView) {
            this.viewContainer.clear();
            this.hasView = false;
        }
    }
}

@Directive({
    selector: '[hasRole]',
})
export class HasRoleDirective extends HasRoleDirectiveBase {
    constructor(
        templateRef: TemplateRef<any>,
        viewContainer: ViewContainerRef,
        private authService: AuthService
    ) {
        super(templateRef, viewContainer);
    }

    @Input('hasRole') set hasAnyRole(value: string | string[]) {
        const roles = toRolesArray(value);
        this.hasRole =
            roles.length === 0 ||
            roles.some((role) => this.authService.hasRole(role));
    }
}

@Directive({
    selector: '[hasAllRoles]',
})
export class HasAllRolesDirective extends HasRoleDirectiveBase {
    constructor(
        templateRef: TemplateRef<any>,
        viewContainer: ViewContainerRef,
        private authService: AuthService
    ) {
        super(templateRef, viewContainer);
    }

    @Input() set hasAllRoles(value: string | string[]) {
        const roles = toRolesArray(value);
        this.hasRole = roles.every((role) => this.authService.hasRole(role));
    }
}

const toRolesArray = (value: string | string[]): string[] => {
    if (typeof value === 'string') {
        return value.split(',').map((x) => x.trim());
    }

    return value;
};
